import instance from "../../../Utils/Interceptors/Interceptor";

const IngresoEventosConcesionService = async (values, archivos = []) => {
    try {
        const formData = new FormData();

        formData.append("IdUsuario", values.IdUsuario);
        formData.append("IdPerfilContexto", values.IdPerfilContexto);
        formData.append("IdIndicador", values.IdIndicador);
        if (values.IdExigencia && !isNaN(values.IdExigencia)) {
            formData.append("IdExigencia", values.IdExigencia);
        }
        formData.append("ListaEventosJson", JSON.stringify(values.ListaEventos));

        archivos.forEach((file) => formData.append("Archivos", file));

        return await instance.Backend.post("/Bitacora/IngresoEventosConcesion", formData);
    } catch (error) {
        console.log(error);
    }
};

export { IngresoEventosConcesionService };
